module.exports = __webpack_public_path__ + "images/illustrations/illustration-soccer-circle@2x-48fa3ce484eae1b6d77865b66d8659ea.webp";